<template>
  <div class="lg:w-full chart-container"
    :style="{'height':heightContainer}"
    >
    <canvas :id="id" ></canvas>
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import Chart from 'chart.js'

export default {
  name: 'Chart',
  props: {
    type: {
      type: String,
      default: 'bar'
    },
    id: {
      type: String,
      default: 'chart'
    },
    label: {
      type: String,
      default: 'chart'
    },
    charData: {
      type: [Array, Object]
    },
    expand: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      ChartData: null,
      myChart: null,
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    heightContainer () {
      return this.expand ? '50vh' : '30vh'
    }
  },
  watch: {
    charData: 'dataChangeHandler',
    darkMode: 'changeDarkmode',
  },
  methods: {
    getColor (property) {
      return getComputedStyle(document.querySelector(':root')).getPropertyValue(property)
    },
    changeDarkmode: function () {
      Chart.defaults.global.defaultFontColor = this.darkMode ? this.getColor('--secondary-100') : this.getColor('--secondary-DEFAULT') 
      this.myChart.config.options.scales.xAxes.forEach(x => {
        x.gridLines.color = this.darkMode ? this.getColor('--darkblue-400') : this.getColor('--primary-100') 
      }) 
      this.myChart.config.options.scales.yAxes.forEach(x => {
        x.gridLines.color = this.darkMode ? this.getColor('--darkblue-400') : this.getColor('--primary-100') 
        x.gridLines.zeroLineColor = this.darkMode ? this.getColor('--darkblue-400') : this.getColor('--primary-100') 
      }) 
      this.myChart.config.data.datasets.forEach(x => {
        x.backgroundColor = this.darkMode ? this.getColor('--primary-DEFAULT') : this.getColor('--primary-100') 
      })
      this.myChart.config.options.legend.labels.fontColor = this.darkMode ? this.getColor('--secondary-100') : this.getColor('--secondary-DEFAULT') 
      this.updateFixChart()
    },
    updateFixChart () {
      this.myChart.update()
      setTimeout(() => {
        this.myChart.update()
      }, 100)
    },
    removeData () {
      this.myChart.data.labels = []
      // this.myChart.data.datasets.forEach(x => x.data=[])
      for (let index = 0; index < this.myChart.data.datasets.length; index++) {
        this.myChart.data.datasets[index].data = []
      }
      // this.myChart.data.labels.pop()
      // this.myChart.data.datasets.forEach(x => x.data.pop())
      this.updateFixChart()
    },
    addData (label, data) {
      this.myChart.data.labels.push(label)
      this.myChart.data.datasets.forEach(x => x.data.push(data))
      this.updateFixChart()
    },
    dataChangeHandler: function () {
      if (this.myChart !== null && this.myChart !== undefined) {
        this.removeData()
        this.charData.forEach(element => {
          this.addData(element.label, element.value)
        })
      } else {
        // this.$emit('toogleLoadingTop', true)
        const self = this
        Chart.defaults.global.defaultFontColor = this.darkMode ? this.getColor('--secondary-100') : this.getColor('--secondary-DEFAULT') 
        const ctx = document.getElementById(this.id)
        const labels = []
        const values = []
        this.charData.forEach(element => {
          labels.push(element.label)
          values.push(element.value)
        })
        this.ChartData = null
        this.ChartData = {
          type: this.type, // 'horizontalBar',
          data: {
            labels: labels,
            datasets: [
              {
                label: this.label,
                data: values,
                backgroundColor: this.darkMode ? this.getColor('--primary-DEFAULT') : this.getColor('--primary-100'),
                borderColor: this.getColor('--primary-200'),
                borderWidth: 2,
                maxBarThickness: 40,
                fontSize: 40,
              },
              // TMP Stacked 
              // {
              //   label: this.label,
              //   data: values,
              //   backgroundColor: 'black',
              //   borderColor: this.getColor('--primary-200') ,
              //   borderWidth: 2,
              //   maxBarThickness: 40,
              //   fontSize: 40,
              // }
            ]
          },
          options: {
            legend: {
              display: true,
              labels: {
                fontColor: this.darkMode ? this.getColor('--secondary-100') : this.getColor('--secondary-DEFAULT'),
                fontSize: 14,
              }
            },
            maintainAspectRatio: false,
            scales: {
              xAxes: [{
                stacked: true,
                gridLines: {
                  color: this.darkMode ? this.getColor('--darkblue-400') : this.getColor('--primary-100'),
                },
                ticks: {
                  precision: 0,
                  fontSize: 14,
                  callback: value => i18n.n(value, 'integer')
                }
              }],
              yAxes: [{
                // TMP Stacked 
                // stacked: true,
                gridLines: {
                  color: this.darkMode ? this.getColor('--darkblue-400') : this.getColor('--primary-100'),
                  zeroLineColor: this.darkMode ? this.getColor('--darkblue-400') : this.getColor('--primary-100') 
                },
                ticks: {
                  beginAtZero: true,
                  fontSize: 14,
                }
              }]
            },
            tooltips: {
              callbacks: {
                label: tooltipItem => `${self.label}: ${i18n.n(tooltipItem.xLabel, 'integer')}`,
              },
            },
            onHover: (event, chartElement) => {
              const target = event.native ? event.native.target : event.target
              target.style.cursor = chartElement[0] ? 'pointer' : 'default'
            }
          }
        }
        // eslint-disable-next-line no-new
        const myChart = new Chart(ctx, this.ChartData)
        this.myChart = myChart
        ctx.onclick = function (evt) {
          const activePoint = myChart.getElementAtEvent(evt)[0]
          if (activePoint && activePoint._chart) {
            const data = activePoint._chart.data
            const datasetIndex = activePoint._datasetIndex
            const label = data.labels[activePoint._index]
            const value = data.datasets[datasetIndex].data[activePoint._index]
            self.$emit('callback', label, value)
          }
        }
        this.updateFixChart()
      }
    },
  }
}
</script>

<style scoped>

.chart-container {
  position: relative;
  /* height: 30vh; */
}
</style>
